const formatShopLink = link =>
  link?.tracking
    ? `${link?.url}?utm_source=waitrose.com&utm_medium=referral&utm_campaign=${link?.tracking}`
    : link?.url;

export default formatShopLink;
